import Spine = PIXI.spine.Spine;
import {TimelineLite} from "gsap";
import {TheCrypt} from "../TheCrypt";
import {TheCryptHelper} from "../utils/TheCryptHelper";
import {SpineTween} from "@nolimitcity/slot-game/bin/animation/SpineTween";
import {TheCryptWinConfig} from "../configs/TheCryptWinConfig";

export class TheCryptReelBackground extends PIXI.Container{
    private _logoAnimation:PIXI.Sprite;
    private _reelFrame:Spine;
    constructor() {
        super();
        this.name = "ReelBackground";
        this.init();
    }

    private init() {
        const reelFrame: Spine = new Spine(TheCrypt.assetLoader.getSpineAsset("reelBg"));
        reelFrame.name = "reelFrame";
        this.position.set(356,380);
        this.addChild(reelFrame);
        reelFrame.state.setAnimation(0, "base", true);
        this._reelFrame = reelFrame;
        this._logoAnimation =TheCryptHelper.createSprite("frame_inneglow", 0, 0);
        this.addChild(this._logoAnimation);
        this._logoAnimation.blendMode = PIXI.BLEND_MODES.SCREEN;
        this._logoAnimation.alpha = 0.6;
        this._logoAnimation.anchor.set(0.5, 0.5);
    }

    public onSpin():void{
        new TimelineLite().to(this._logoAnimation, 0.5,{alpha:0}).to(this._logoAnimation, 0.5,{alpha:0.6});
        new SpineTween(this._reelFrame, 1, `spin`)
    }

    public setMode(mode:string): void {
        this._reelFrame.skeleton.setSkinByName(TheCryptHelper.isNormal(mode)?"main":"FS");
    }

    public onWinToggle(): void {
        const winRatio: number = TheCrypt.model.avalancheWinRatio,
            bigWinRatio = TheCryptWinConfig.WIN_RATIOS.bigWin;

        if (winRatio < bigWinRatio[0].ratio) {
            return;
        }

        if (winRatio >= bigWinRatio[2].ratio) {
            new SpineTween(this._reelFrame, 1, `initial_bigwin_3`);
        } else if (winRatio >= bigWinRatio[1].ratio) {
            new SpineTween(this._reelFrame, 1, `initial_bigwin_2`);
        } else {
            new SpineTween(this._reelFrame, 1, `initial_bigwin_1`);
        }
    }
}